
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRefreshGoogle as ObiRefreshGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-refresh-google.js';
 
 
 

 
 export const ObiRefreshGoogle = createComponent({
   react: React,
   tagName: 'obi-refresh-google',
   elementClass: ObiRefreshGoogleElement,
   events: {
     
   }
  });
 
 